<template>
    <div class="app-container">
      <div class="table__page">
        <el-row style="margin-top: 10px;margin-bottom: 20px">
          <el-col :span="6">
            <label style="font-size: 18px">关于我们</label>
          </el-col>
        </el-row>
        <hr style="color: #8b8b8b">
        <el-row style="margin-top: 25px">
          <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
        </el-row>
        <el-row style="margin-top: 25px; text-align: center;">
            <el-button type="default" size="small" v-if="isEditFlag" @click="toCancel">取消</el-button>
            <wt-auth :hasAnyPremission="'MODULE_ABOUTUS:EDIT'" class="search-form-btn">
              <el-button type="primary" size="small" v-if="!isEditFlag" @click="toEdit">编辑</el-button>
            </wt-auth>
            <el-button type="primary" size="small" v-if="isEditFlag" @click="saveBtn">保存</el-button>
        </el-row>
      </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'Aboutus',
  data() {
    return {
      isEditFlag: false,
      detailForm: {
        title: '',
        className: 'wt-section-long-content',
        elements: [
          { name: '标题', key: 'title', type: 'text', disabled: true, className: 'wt-col-6', required: false },
          { name: '图片', key: 'coverList', type: 'image', disabled: true, required: false, limit: 1, markText: '上传图片尺寸180x180px' },
          { name: '内容', key: 'content', type: 'editor', disabled: true, required: false }]
      },
      detailFormData: {}
    }
  },
  methods: {
    toEdit() {
      for (const item of this.detailForm.elements) {
        item.disabled = false
        item.required = true
      }
      this.isEditFlag = true
    },
    toCancel() {
      for (const item of this.detailForm.elements) {
        item.disabled = true
        item.required = false
      }
      this.isEditFlag = false
      this.systemDetail()
    },
    saveBtn() {
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.cover = this.detailFormData.coverList[0].fileUrl
      request.post('/modules/system/systemUpdate', sendData).then(res => {
        if (!res) return false
        this.toCancel()
      })
    },
    systemDetail(flag) {
      request.post('/modules/system/systemDetail', { type: 2 }).then(res => {
        res.data = res.data ? res.data : { type: 2 }
        if (flag) {
          if (res.data.cover) {
            res.data.coverList = [{ fileUrl: res.data.cover }]
          } else {
            res.data.coverList = []
          }
          this.detailFormData = res.data
        } else {
          if (res.data.coverList && res.data.coverList.length > 0) {
            this.detailFormData.coverList[0].fileUrl = res.data.cover
          }
          this.detailFormData.title = res.data.title
          this.detailFormData.content = res.data.content
        }
      })
    }
  },
  mounted() {
    this.systemDetail(true)
  }
}
</script>
